var map = {
	"./Results1946.json": 3110,
	"./Results1947.json": 5027,
	"./Results1948.json": 1175,
	"./Results1949.json": 260,
	"./Results1950.json": 7055,
	"./Results1951.json": 4704,
	"./Results1952.json": 2001,
	"./Results1953.json": 4523,
	"./Results1954.json": 9875,
	"./Results1955.json": 1385,
	"./Results1956.json": 245,
	"./Results1957.json": 8478,
	"./Results1958.json": 2955,
	"./Results1959.json": 2931,
	"./Results1960.json": 829,
	"./Results1961.json": 1986,
	"./Results1962.json": 4849,
	"./Results1963.json": 3633,
	"./Results1964.json": 7441,
	"./Results1965.json": 6064,
	"./Results1966.json": 3733,
	"./Results1967.json": 3768,
	"./Results1968.json": 7319,
	"./Results1969.json": 4044,
	"./Results1970.json": 9727,
	"./Results1971.json": 7060,
	"./Results1972.json": 2907,
	"./Results1973.json": 9499,
	"./Results1974.json": 7762,
	"./Results1975.json": 6865,
	"./Results1976.json": 7870,
	"./Results1977.json": 6283,
	"./Results1978.json": 1622,
	"./Results1979.json": 6815,
	"./Results1980.json": 1529,
	"./Results1981.json": 4189,
	"./Results1982.json": 8133,
	"./Results1983.json": 9892,
	"./Results1984.json": 2583,
	"./Results1985.json": 6475,
	"./Results1986.json": 8002,
	"./Results1987.json": 2515,
	"./Results1988.json": 4273,
	"./Results1989.json": 3437,
	"./Results1990.json": 8324,
	"./Results1991.json": 3870,
	"./Results1992.json": 6966,
	"./Results1993.json": 704,
	"./Results1994.json": 2733,
	"./Results1995.json": 1665,
	"./Results1996.json": 763,
	"./Results1997.json": 7833,
	"./Results1998.json": 5804,
	"./Results1999.json": 9483,
	"./Results2000.json": 3454,
	"./Results2001.json": 4567,
	"./Results2002.json": 2467,
	"./Results2003.json": 3881,
	"./Results2004.json": 9084,
	"./Results2005.json": 7419,
	"./Results2006.json": 2986,
	"./Results2007.json": 1414,
	"./Results2008.json": 4566,
	"./Results2009.json": 5423,
	"./Results2010.json": 7972,
	"./Results2011.json": 8068,
	"./Results2012.json": 3184,
	"./Results2013.json": 7335,
	"./Results2014.json": 4471,
	"./Results2015.json": 400,
	"./Results2016.json": 6554,
	"./Results2017.json": 4380,
	"./Results2018.json": 2041,
	"./Results2019.json": 4302,
	"./Results2020.json": 1574,
	"./Results2021.json": 2201,
	"./Results2022.json": 4066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1709;